/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { createGlobalStyle, css } from "styled-components";

export const focusRingStyles = css`
  outline: 2px solid rgb(${({ theme }) => theme.colors.link.rgb});
  outline-offset: 1px;
`;

export const focusRingInsetStyles = css`
  ${focusRingStyles}
  outline-offset: -1px;
`;

export const widgetResetStyles = css`
  --icon-stroke: rgb(${({ theme }) => theme.colors.iconStroke.rgb});
  --text: rgb(${({ theme }) => theme.colors.text.rgb});

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  h1,
  h2,
  h3,
  h4,
  p,
  figure,
  blockquote,
  dl,
  dd {
    margin: 0;
  }

  ul,
  ol {
    margin: 0;
    padding: 0;
    list-style: none;
    list-style-position: inside;
  }

  p ul,
  p ol {
    margin: initial;
    padding: initial;
    list-style: initial;
    list-style-position: inside;
  }

  h1,
  h2,
  h3,
  h4 {
    text-wrap: balance;
  }

  a:focus:not(:focus-visible) {
    outline: none;
  }

  :where(
    a[href],
    button,
    summary,
    input,
    select,
    textarea,
    [role="button"],
    [role="radio"],
    [role="option"],
    [role="tab"],
    [tabindex]:not([tabindex="-1"])
  ):focus-visible {
    ${focusRingStyles}
  }

  :where(
    label,
    [role="button"],
    [role="radio"],
    [role="option"],
    [role="tab"],
    [role="menuitem"]
  ) {
    -webkit-user-select: none;
    user-select: none;
  }

  a:not([class]) {
    text-decoration: none;
    color: inherit;
  }

  img,
  picture {
    display: block;
    width: 100%;
    max-width: 100%;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  textarea:not([rows]) {
    min-height: 10em;
  }

  :target {
    scroll-margin-block: 5ex;
  }

  fieldset {
    border: 0;
    margin: 0;
    padding: 0;
    outline: none;
  }

  @media (prefers-reduced-motion: reduce) {
    &,
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;

const GlobalWidgetStyle = createGlobalStyle`
  /* Authorize.net payment block */

  #AcceptUIContainer {
    left: 50% !important;
    top: 50% !important;
    margin: 0 !important;
    transform: translate(-50%, -50%) !important;

    @media (max-width: 768px) {
      width: 100% !important;
      top: 0 !important;
      transform: translate(-50%, 0) !important;
    }
  }
`;

export default GlobalWidgetStyle;
